var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part part-2"},[_vm._m(0),_c('div',{staticClass:"game__icon"}),_c('div',{staticClass:"game__count"},[_c('p',[_vm._v("準備開始囉！")]),_c('span',[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game__title"},[_c('p',[_vm._v("食指蓋住"),_c('span',[_vm._v("後鏡頭")]),_c('br'),_vm._v("讀取心跳脈搏")])])
}]

export { render, staticRenderFns }